import React, { useContext, useEffect, useState } from 'react';
import Close from '../../../../Assets/Modals/closeIcon.svg';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../../../Features/couponsSlice';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { DatePicker } from "@mui/x-date-pickers";
import { CalendarIcon } from '@mui/x-date-pickers';
import { showToast } from '../../../../Components/Toaster/Toaster';
import { AddCouponFormContext } from '../../../../Context/Coupons/AddCouponFormContext';
import { stripTimeFromDate } from '../../../../lib/utils/utils';

function SelectDuration() {
    const dispatch = useDispatch();

    const { setDate } = useContext(AddCouponFormContext);

    const dates = {
        from: null,
        to: null,
    }

    const [localDate, setLocalDate] = useState(dates);

    const [buttonAvailable, setButtonAvailable] = useState(false);

    const handleCloseButtonClick = () => {
        dispatch(closeModal());
    };

    const handleSaveDuration = () => {
        const fromDate = stripTimeFromDate(new Date(localDate.from));
        const toDate = stripTimeFromDate(new Date(localDate.to));
        const currentDate = stripTimeFromDate(new Date());
    
        const fromTimestamp = fromDate.getTime();
        const toTimestamp = toDate.getTime();
    
        if (fromTimestamp || toTimestamp) {
            if (!fromTimestamp) {
                showToast('Select start date.', 'warning');
                return;
            }
            else if (!toTimestamp) {
                showToast('Select end date.', 'warning');
                return;
            }
            else if (fromDate > toDate) {
                showToast('Start date should be earlier than end date.', 'warning');
                return;
            }
            else if (currentDate > toDate) {
                showToast('End date should not be in the past.', 'warning');
                return;
            }
            else {
                setDate({
                    from: fromDate.toISOString(),
                    to: toDate.toISOString()
                });
                dispatch(closeModal());
            }
        }
        else {
            showToast('Select dates to continue.', 'warning');
            return;
        }
    };

    useEffect(() => {
        if(localDate.from && localDate.to) {
            setButtonAvailable(true);
        }
        else {
            setButtonAvailable(false);
        }
    }, [localDate]);

    return (
        <div className='w-3/5 px-6 py-[18px] shadow-[0px_0px_12px_0px_#0000003D] bg-[#FFFFFF] flex flex-col gap-6 rounded-xl'>
            <div className="flex flex-col gap-[14px]">
                <div className="flex flex-col gap-1">
                    <div className="flex items-center justify-between">
                        <h1 className='font-semibold text-2xl text-[#121212]'>Set Duration</h1>

                        <div onClick={handleCloseButtonClick} className="size-11 flex items-center justify-center cursor-pointer">
                            <img src={Close} alt="" />
                        </div>
                    </div>

                    <p className='text-[16px] leading-7 text-[#666666]'>This feature allows you to define the time period during which this Coupon will be visible within this category in the store.</p>
                </div>

                <div className="flex gap-8 text-black font-urbanist-regular">
                    <div className="flex flex-col gap-1">
                        <h1 className='font-normal text-base'>From</h1>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['DatePicker']}>
                                <DatePicker
                                    disablePast
                                    label="Start Date" 
                                    onChange={e => setLocalDate({ ...localDate, from: e.$d })} 
                                    slots={{ openPickerIcon: CalendarIcon }} 
                                    sx={{
                                        width: '180px'
                                    }}
                                />
                            </DemoContainer>
                        </LocalizationProvider>
                    </div>

                    <div className="flex flex-col gap-1">
                        <h1 className='font-normal text-base'>To</h1>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['DatePicker']}>
                                <DatePicker
                                    disablePast
                                    label="End Date" 
                                    onChange={e => setLocalDate({ ...localDate, to: e.$d })} 
                                    slots={{ openPickerIcon: CalendarIcon, }} 
                                    sx={{
                                        width: '180px',
                                    }}
                                />
                            </DemoContainer>
                        </LocalizationProvider>
                    </div>
                </div>
            </div>

            <button onClick={handleSaveDuration} className={`outline-none px-4 py-2 ${buttonAvailable ? 'bg-primaryColor hover:bg-primaryAccent' : 'bg-buttonDisabledBg cursor-not-allowed'} text-buttonText rounded font-semibold text-base`}>Save Duration</button>
        </div>
    );
}

export default SelectDuration;
